import { useEffect, useState } from "react";
import SwiperCore, {
  Autoplay,
  Grid,
  Navigation,
  Pagination,
  Scrollbar,
} from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
SwiperCore.use([Navigation, Autoplay, Scrollbar, Pagination, Grid]);
import * as C from "./Customizing.styles";
import { Spinner } from "react-bootstrap";
import { useRouter } from "next/router";
import { CategoryListSet } from "../../../api/makeCategorys";
import { failAlert } from "../../../common/alert";

const CustomizingCate = ({ cateRef }) => {
  const router = useRouter();
  const [firstCateSwiper, setFirstCateSwiper] = useState();
  const [secondCateSwiper, setSecondCateSwiper] = useState();
  // 카테고리 타입
  const [categoryType, setCategoryType] = useState("S");
  // 1차 카테고리 리스트
  const [firstCategoryList, setFirstCategoryList] = useState([]);
  const [firstCategory, setFirstCategory] = useState("");
  // 2차 카테고리 리스트
  const [secondCategoryList, setSecondCategoryList] = useState([]);
  const [secondCategory, setSecondCategory] = useState("");
  // 카테고리 불러오기 loading
  const [cateLoading, setCateLoading] = useState(false);

  const handleCategoryType = (type) => {
    setCategoryType(type);

    sessionStorage.setItem(
      `__next_scroll_${router.pathname}`,
      JSON.stringify({
        x: window.scrollX,
        y: window.scrollY,
      })
    );
    setFirstCategory("");

    router.push({
      pathname: "",
      query: {
        type: type,
      },
    });
  };

  // N차 카테고리 불러오기
  const fetchCategoryList = async (depth, el) => {
    const body = {
      modes: "CategoryListSet",
      division: router.query.type || categoryType,
      code: el?.code ? el.code : "",
    };
    const res = await CategoryListSet(body);

    if (res.Code !== "0000") {
      return failAlert(res.Data?.Msg || "카테고리 요청 실패");
    }
    if (depth === 1) {
      setFirstCategoryList(res.Data?.Category);
      if (router.query.first) {
        const first = res.Data?.Category.find(
          (el) => el.code === router.query.first
        );
        setFirstCategory(first);
        fetchCategoryList(2, first);
      }
      return;
    }
    if (depth === 2) {
      setSecondCategoryList(res.Data?.Category);
      if (!res.Data?.Category || res.Data?.Category.length < 1) {
        setSecondCategory(el);
      } else {
        setCateLoading(false);
      }
    }
  };

  // 1차 카테고리 선택 함수
  const selectFirstCategory = (el) => async () => {
    setCateLoading(true);
    setSecondCategory("");
    setSecondCategoryList([]);
    setFirstCategory(el);
    await fetchCategoryList(2, el);
    sessionStorage.setItem(
      `__next_scroll_${router.pathname}`,
      JSON.stringify({
        x: window.scrollX,
        y: window.scrollY,
      })
    );
    router.push({
      pathname: ``,
      query: {
        ...router.query,
        first: el.code,
        code: "",
      },
    });
  };

  // 2차 카테고리 선택 함수
  const selectSecondCategory = (el) => async () => {
    setSecondCategory(el);
    sessionStorage.setItem(
      `__next_scroll_${router.pathname}`,
      JSON.stringify({
        x: window.scrollX,
        y: window.scrollY,
      })
    );
    if (cateRef) {
      setTimeout(() => {
        window.scrollTo({
          behavior: "smooth",
          left: 0,
          top:
            window.innerWidth > 991
              ? cateRef.current.scrollHeight + 100
              : cateRef.current.scrollHeight,
        });
      }, [200]);
    }
    router.push({
      pathname: `/customizing/customizing-products/new`,
      query: {
        ...router.query,
        code: el.code,
      },
    });
  };

  useEffect(() => {
    setCateLoading(true);

    if (!router.isReady) return;
    if (router.query.type) {
      setCategoryType(router.query.type);
    } else {
      setCategoryType("S");
    }
    fetchCategoryList(1);

    if (cateRef && !secondCategory && !firstCategory && router.query.code) {
      setTimeout(() => {
        window.scrollTo({
          behavior: "smooth",
          left: 0,
          top:
            window.innerWidth > 991
              ? cateRef.current.scrollHeight + 100
              : cateRef.current.scrollHeight,
        });
        setCateLoading(false);
      }, [300]);
    }

    const routeChangeCompleteHandler = () => {
      // 페이지 이동 후 저장되어 있던 위치로 스크롤 복원
      const _scroll = sessionStorage.getItem(
        `__next_scroll_${router.pathname}`
      );
      if (_scroll) {
        // 스크롤 복원 후 저장된 위치 제거
        const { x, y } = JSON.parse(_scroll);
        window.scrollTo(x, y);
        sessionStorage.removeItem(`__next_scroll_${router.pathname}`);
      }
    };

    router.events.on("routeChangeComplete", routeChangeCompleteHandler);
    setCateLoading(false);
    return () => {
      router.events.off("routeChangeComplete", routeChangeCompleteHandler);
    };
  }, [router.isReady, router.query]);

  return (
    <>
      {cateLoading && (
        <div className="loading_container position-fixed d-flex align-items-center justify-content-center">
          <Spinner animation="border" role="status" />
        </div>
      )}
      <C.CustomizingCateSection>
        <C.TypeWrapper>
          <C.TypeBtn
            categoryType={categoryType === "S"}
            onClick={() => handleCategoryType("S")}
          >
            <div className="title">
              <span>원하시는 포장재가 있으신가요?</span>
              <h6>포장재 먼저 선택하기</h6>
            </div>
            <div className="icon">
              <i className="fi-rs-check-circle" />
            </div>
          </C.TypeBtn>
          <C.TypeBtn
            categoryType={categoryType === "T"}
            onClick={() => handleCategoryType("T")}
          >
            <div className="title">
              <span>어떤 포장재를 골라야 될지 어려우신가요?</span>
              <h6>포장 할 제품을 먼저 선택하기</h6>
            </div>
            <div className="icon">
              <i className="fi-rs-check-circle" />
            </div>
          </C.TypeBtn>
        </C.TypeWrapper>
        {/* 1차 */}
        {categoryType && (
          <C.CategoryWrapper>
            <Swiper
              id="firstCateSwiper"
              className="cateSwiper"
              navigation={{
                prevEl: ".custom_prev_fct",
                nextEl: ".custom_next_fct",
              }}
              slidesPerView={4}
              slidesPerGroup={4}
              centeredSlides={false}
              breakpoints={{
                991: {
                  slidesPerView: 7,
                  slidesPerGroup: 7,
                },
                768: {
                  slidesPerView: 6,
                  slidesPerGroup: 6,
                },
              }}
              initialSlide={0}
              spaceBetween={20}
              grabCursor={true}
              observer={true}
              onSwiper={setFirstCateSwiper}
              onSlideChange={(swiper) =>
                setFirstCateSwiper({
                  ...firstCateSwiper,
                  realIndex: swiper.realIndex,
                })
              }
            >
              {firstCategoryList &&
                firstCategoryList.map((cate, cateIdx) => (
                  <SwiperSlide key={cateIdx}>
                    <C.CateBox
                      onClick={selectFirstCategory(cate)}
                      active={firstCategory?.code === cate.code || false}
                    >
                      <figure className="">
                        <img src={cate.image} alt={cate.name} />
                      </figure>
                      <span>{cate.name}</span>
                    </C.CateBox>
                  </SwiperSlide>
                ))}
            </Swiper>
            <C.SlideArrows className="slider-arrow">
              <span
                className="custom_prev_fct"
                style={{
                  visibility:
                    firstCateSwiper && firstCateSwiper?.realIndex == 0
                      ? "hidden"
                      : "visible",
                }}
              >
                <i className="fi-rs-angle-left"></i>
              </span>
              <span
                className="custom_next_fct"
                style={{
                  visibility:
                    firstCateSwiper &&
                    firstCateSwiper?.realIndex +
                      (Number(firstCateSwiper?.currentBreakpoint) < 991
                        ? 6
                        : 7) >=
                      firstCategoryList?.length
                      ? "hidden"
                      : "visible",
                }}
              >
                <i className="fi-rs-angle-right"></i>
              </span>
            </C.SlideArrows>
          </C.CategoryWrapper>
        )}
        {/* 2차 */}
        {firstCategory && secondCategoryList && (
          <C.CategoryWrapper>
            <Swiper
              id="secondCateSwiper"
              className="cateSwiper"
              navigation={{
                prevEl: ".custom_prev_sct",
                nextEl: ".custom_next_sct",
              }}
              slidesPerView={4}
              slidesPerGroup={4}
              centeredSlides={false}
              breakpoints={{
                991: {
                  slidesPerView: 7,
                  slidesPerGroup: 7,
                },
                768: {
                  slidesPerView: 6,
                  slidesPerGroup: 6,
                },
              }}
              initialSlide={0}
              spaceBetween={20}
              grabCursor={true}
              observer={true}
              onSwiper={setSecondCateSwiper}
              onSlideChange={(swiper) =>
                setSecondCateSwiper({
                  ...secondCateSwiper,
                  realIndex: swiper.realIndex,
                })
              }
            >
              {secondCategoryList.map((cate, cateIdx) => (
                <SwiperSlide key={cateIdx}>
                  <C.CateBox
                    onClick={selectSecondCategory(cate)}
                    active={router.query.code === cate.code}
                  >
                    <figure className="">
                      <img src={cate.image} alt={cate.name} />
                    </figure>
                    <span>{cate.name}</span>
                  </C.CateBox>
                </SwiperSlide>
              ))}
            </Swiper>
            <C.SlideArrows className="slider-arrow">
              <span
                className="custom_prev_sct"
                style={{
                  visibility:
                    secondCateSwiper && secondCateSwiper?.realIndex == 0
                      ? "hidden"
                      : "visible",
                }}
              >
                <i className="fi-rs-angle-left"></i>
              </span>
              <span
                className="custom_next_sct"
                style={{
                  visibility:
                    secondCateSwiper &&
                    secondCateSwiper?.realIndex + 7 >=
                      secondCategoryList?.length
                      ? "hidden"
                      : "visible",
                }}
              >
                <i className="fi-rs-angle-right"></i>
              </span>
            </C.SlideArrows>
          </C.CategoryWrapper>
        )}
      </C.CustomizingCateSection>
    </>
  );
};
export default CustomizingCate;
